import {
  EntityConnectionFragment,
  EntityConnectionsFragment
} from "generated/graphql";

export type EntityConnectionsInfoType = EntityConnectionsFragment["entityConnections"];

export const useEntityConnections = (
  entityConnections?: EntityConnectionsInfoType
) => {
  if (!entityConnections || entityConnections.total === 0) return;

  const connectedDevices = entityConnections.edges
    ?.map(edge => edge.node)
    ?.reduce((acc, curr) => {
      const { replace, index, add } = entityConnectionsReducer(
        acc.map(el => {
          return {
            id: el.targetEntityId,
            type: el.type,
            connected: el.connected
          };
        }),
        { id: curr.targetEntityId, connected: curr.connected, type: curr.type }
      );
      if (replace) {
        acc[index] = curr;
      } else if (add) {
        acc!.push(curr);
      }
      return acc;
    }, [] as EntityConnectionFragment[]);

  return connectedDevices;
};

type reducerInputType = { id: string; type: string; connected: boolean };

const entityConnectionsReducer = (
  arrayOfConnections: Array<reducerInputType>,
  connection: reducerInputType
) => {
  let replaceElement = false,
    addElement = false;
  const addedTargetIndex = arrayOfConnections!.findIndex(
    el => el.id.toLocaleLowerCase() === connection.id.toLocaleLowerCase()
  );
  if (addedTargetIndex >= 0) {
    if (
      arrayOfConnections[addedTargetIndex].type?.length === 0 &&
      connection.type?.length !== 0
    ) {
      replaceElement = true;
    }
  } else {
    addElement = true;
  }
  return { replace: replaceElement, index: addedTargetIndex, add: addElement };
};
